import DetectLanguage from 'detectlanguage';

const detectlanguage = new DetectLanguage('1a10c41e8c78f7f0d0a43053a7c3ba0e');

export default detectlanguage;
